import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import cnIcon1 from '../../../images/icons/icon_php.svg'
import cnIcon2 from '../../../images/icons/icon_javascript.svg'
import cnIcon3 from '../../../images/case/icon_elephent.svg'
import cnIcon5 from '../../../images/icons/icon_typescript.svg'
import cnIcon8 from '../../../images/icons/icon_java.svg'
import cnIcon10 from '../../../images/icons/icon_c_plus.svg'
import cnIcon11 from '../../../images/icons/icon_react_js.svg'
import cnIcon12 from '../../../images/icons/icon_laravel.svg'
import cnIcon4 from '../../../images/icons/bootstrap.svg'
import material from '../../../images/icons/material.svg'
import redux from '../../../images/icons/redux.svg'
import tailwind from '../../../images/icons/tailwind.svg'
import mongoDB from '../../../images/icons/mongodb.svg'
import cloud from '../../../images/icons/cloud.svg'
import oracle from '../../../images/icons/oracle.svg'
import mysql from '../../../images/icons/mysql.svg'
import sqllite from '../../../images/icons/sqllite.svg'
import postgreSQL from '../../../images/icons/postgresql.svg'
import figma from '../../../images/icons/figma.svg'
import canva from '../../../images/icons/canva.svg'
import adobexd from '../../../images/icons/adobexd.svg'
import adobeill from '../../../images/icons/adobeillustrator.svg'
import adobephotoshop from '../../../images/icons/photoshop.svg'
import adobeafter from '../../../images/icons/adobeafter.svg'
import adobepremium from '../../../images/icons/adobepremiere.svg'
import moz from '../../../images/icons/moz.svg'
import manglos from '../../../images/icons/mongos.PNG'
import wordstream from '../../../images/icons/wordstream.png'


import Bg from '../../../images/shapes/shape_title_under_line.svg'


const TechnologyList = [
    {
        Id: '1',
        sIcon: cnIcon1,
        title: 'PHP',
    },
    {
        Id: '2',
        sIcon: cnIcon2,
        title: 'JavaScript',
    },
    {
        Id: '4',
        sIcon: cnIcon5,
        title: 'Typescript',
    },
  
    {
        Id: '6',
        sIcon: cnIcon10,
        title: 'C++',
    },
    {
        Id: '7',
        sIcon: cnIcon11,
        title: 'React Js',
    },
    {
        Id: '8',
        sIcon: cnIcon12,
        title: 'Laraval',
    }, 
    {
        Id: '9',
        sIcon: cnIcon4,
        title: 'Bootstrap',
    },
    {
        Id: '10',
        sIcon: tailwind,
        title: 'Tailwind',
    },
    {
        Id: '11',
        sIcon: redux,
        title: 'Redux',
    },
    {
        Id: '12',
        sIcon: material,
        title: 'Material UI',
    },
    
]
const database = [
    {
        Id: '1',
        sIcon: mysql,
        title: 'MySQL',
    },
    {
        Id: '2',
        sIcon: mongoDB,
        title: 'MongoDB',
    },
    {
        Id: '3',
        sIcon: postgreSQL,
        title: 'PostgreSQL',
    },
   
    {
        Id: '4',
        sIcon: oracle,
        title: 'Oracle',
    },
  
    {
        Id: '5',
        sIcon: sqllite,
        title: 'SQLLite',
    },
   
    {
        Id: '6',
        sIcon: cloud,
        title: 'Cloud Database',
    }
    
]
const seo = [
    {
        Id: '1',
        sIcon: moz,
        title: 'MOZ',
    },
    {
        Id: '2',
        sIcon: manglos,
        title: 'KWFinder',
    },
    {
        Id: '2',
        sIcon: wordstream,
        title: 'WordStream',
    }

    
]

const graphic = [
    {
        Id: '1',
        sIcon: adobephotoshop,
        title: 'Adobe Photoshop',
    },
    {
        Id: '2',
        sIcon: adobeill,
        title: 'Adobe Illustrator',
    },
    {
        Id: '3',
        sIcon: adobeafter,
        title: 'Adobe After Effects',
    },
     {
        Id: '5',
        sIcon: adobepremium,
        title: 'Adobe Premiere Pro',
    }, {
        Id: '5',
        sIcon: canva,
        title: 'Canva Pro',
    }, {
        Id: '5',
        sIcon: figma,
        title: 'Figma',
    },
    {
        Id: '5',
        sIcon: adobexd,
        title: 'Adobe XD',
    },
   

    
]

const TechnologySection = (props) => {

    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }


    return (

        <div className="section_space">
            <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                    Our Technologies
                </div>
                <h2 className="heading_text mb-0">
                    We Use <mark>Technologies</mark>
                </h2>
            </div>

            <div className="tab_block_wrapper">
                <Nav tabs className="nav justify-content-center">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            Web Platform
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}
                        >

                            Databases
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >

                            SEO
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => { toggle('4'); }}
                        >

                            Graphic Design
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '5' })}
                            onClick={() => { toggle('5'); }}
                        >

                            Other Frameworks
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(0, 12).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="web_development_technologies row justify-content-center">
                            {database.map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="web_development_technologies row justify-content-center">
                            {seo.map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="4">
                        <div className="web_development_technologies row justify-content-center">
                            {graphic.map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                    <TabPane tabId="5">
                        <div className="web_development_technologies row justify-content-center">
                            {TechnologyList.slice(3, 10).map((technology, cnt) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                    <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                        <div className="iconbox_icon">
                                            <img src={technology.sIcon} alt="" />
                                        </div>
                                        <div className="iconbox_content">
                                            <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default TechnologySection;